<template>
  <div class="l-row">
    <product-status :module="module" @change="onChange"/>
  </div>
</template>

<script>
  import ProductStatus from '@/components/tool/batch/shared/filters/marketplace/ProductStatus'
  import { merge } from 'lodash'

  export default {
    data: () => ({
      filters: null
    }),
    props: {
      module: {
        type: Object,
        required: true
      }
    },
    methods: {
      onChange (filters) {
        this.filters = merge(filters, this.filters)
      }
    },
    components: {
      ProductStatus
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Madeira.vue?10f5bca5